import categoryObject from '~/constants/categories.json';

/**
 * @return {Array} Main categories
 */
export function getMainCategories() {
  const categories = categoryObject.categories;
  return categoryObject.headerTree
    .map((cat) => cat.categories.map((sub) => categories[sub]))
    .flat()
    .filter(Boolean);
}

/**
 * @return {String} Version number
 */
export function getCategoryVersion() {
  return categoryObject.treeVersion;
}

/**
 * @return {Object} category
 */
export function getCategory(path) {
  return categoryObject.categories[path] || {};
}

/**
 * @return {Object} Category Text Style
 */
export function categoryTextStyle(path) {
  const coloredCategoryList = ['/yazio', '/vitrin'];
  if (!coloredCategoryList.includes(path)) {
    return {};
  }
  const category = categoryObject.categories[path];
  return { color: category?.color };
}
